import { render, staticRenderFns } from "./activeIntroduce.vue?vue&type=template&id=26672ce6&scoped=true&"
import script from "./activeIntroduce.vue?vue&type=script&lang=js&"
export * from "./activeIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./activeIntroduce.vue?vue&type=style&index=0&id=26672ce6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26672ce6",
  null
  
)

export default component.exports